import { render, staticRenderFns } from "./SalaryPdf.vue?vue&type=template&id=aecce8ea&scoped=true&"
import script from "./SalaryPdf.vue?vue&type=script&lang=js&"
export * from "./SalaryPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecce8ea",
  null
  
)

export default component.exports